'use strict';

/*global WinsHandsontable*/
/*global Sortable*/
/*global echo*/

function BulkEditAbstract(containerId) {
    this.containerId = containerId;
    this.$container = null;

    this.bulkEditTable = null;
    this.$bulkEditTable = null;

    this.tableColumns = [];
    this.tableData = [];
    this.tableErrors = [];

    this.sorts = [];

    this.init();
}

BulkEditAbstract.prototype = $.extend({}, {
    construtor: 'BulkEditAbstract',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.on('submit', function submitFormClb() {

            _this.submitForm();
        });

        _this.$container.on('change',  'input:visible, select:visible', function changeFormFilterClb() {
            _this.changeFormFilter();
        });

        _this.$container.on('click',  '.bulk-column-btn-remove', function removeColumnClb() {
            _this.removeColumn($(this).closest('.bulk-column-btn'));

            return false;
        });

        return _this;
    },

    //**************************************************************************    

    submitForm: function submitForm() {
        var _this = this;  

        var data = _this.bulkEditTable.getData();
        _this.$container.find('[name="data"]').val(JSON.stringify(data));
        
        return _this;
    },

    changeFormFilter: function changeFormFilter() {
        var _this = this;

        _this.$container.find('[name="step"]').val(1);
        _this.$container.submit();

        return _this;
    },

    removeColumn: function ($column) {
        var _this = this;

        _this.$container.find('.bulk-column-btn-list-source').append($column);
        _this.changeColumns();

        return _this;
    },

    changeColumns: function changeColumns() {
        var _this = this;

        _this.$container.find('[name^=column]').remove();
        _this.$container.find('.bulk-column-btn-list-target').find('.bulk-column-btn').each(function () {
            var $column = $(this);

            _this.$container.append($('<input>', { type: 'hidden', name: 'column[]', value: $column.data('column') }));
        });

        _this.initBulkEditTable();

        return _this;
    },

    setColumns: function setColumns(columns) {
        var _this = this;

        _this.tableColumns = columns;

        return _this;
    },

    setData: function setData(data) {
        var _this = this;

        _this.tableData = data;

        return _this;        
    },
    
    setErrors: function setErrors(errors) {
        var _this = this;

        _this.tableErrors = errors;

        return _this;
    },

    getBulkEditTableColumns: function getBulkEditTableColumns() {
        var _this = this;

        var tableColumns = [];

        _this.$container.find('[name^=column]').each(function () {
            var $column = $(this);

            $.each(_this.tableColumns, function (key, tableColumn) {
                if (tableColumn.data === $column.val()) {
                    tableColumns.push(tableColumn);
                }
            });
        });

        return tableColumns;
    },

    initBulkEditTable: function initBulkEditTable() {
        var _this = this;

        _this.$bulkEditTable = _this.$container.find('.bulk-edit-table');

        if (_this.bulkEditTable) {
            _this.bulkEditTable.destroy();
        }

        //nacteme pouze ty sloupce, ktere ma uzivatel zvolene, ze chce zobrazit
        var tableColumns = _this.getBulkEditTableColumns();

        if (tableColumns) {
            _this.bulkEditTable = new WinsHandsontable(_this.$bulkEditTable, $.extend({}, _this.getBulkEditTableSetting(), {
                data: _this.tableData,
                columns: tableColumns
            }));

            _this.bulkEditTable.setErrors(_this.tableErrors);
        }
    },

    createSortable: function createSortable() {
        var _this = this;

        var $listsWrapper = _this.$container.find('.bulk-column-btn-lists');

        if(_this.sorts.length) {
            $.each(_this.sorts, function (key, sort) {
                sort.destroy();
            });
        }
                       
        [].forEach.call($listsWrapper[0].getElementsByClassName('bulk-column-btn-list'), function (list) {
            var sort = Sortable.create(list, {
                group: 'buttons',
                animation: 150,
                draggable: '.bulk-column-btn-draggable',
                onUpdate: function () {
                    _this.changeColumns();
                },
                onAdd: function () {
                    _this.changeColumns();
                }
            });

            _this.sorts.push(sort);  
        });                                    
	
    },

    //**************************************************************************

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerId);

        _this.registerCallbacks();
        _this.createSortable();

        return _this;
    }
});
